import React, { useState } from 'react';
import { SearchInput, Square } from '@grubhubprod/gh-cookbook-react';

interface SearchDropdownSectionProps {
  onSearchChange: (value: string) => void; // Callback for search value updates
}

export const SearchDropdownSection: React.FC<SearchDropdownSectionProps> = ({
  onSearchChange,
}) => {
  const [searchValue, setSearchValue] = useState<string>('');

  return (
    <Square inset="sm">
      <SearchInput
        label=""
        aria-label="Search"
        variant="secondary"
        autoFocus
        value={searchValue}
        onChange={(v): void => {
          setSearchValue(v);
          onSearchChange(v);
        }}
        onSubmit={(): void => onSearchChange(searchValue)}
      />
    </Square>
  );
};
